<article
  class="flex items-center gap-4 rounded-xl border px-4 py-4 transition-all duration-200"
  [ngClass]="{
    'absolute h-px w-px overflow-hidden whitespace-nowrap border-0 opacity-0': dragging,
    'border-lGray700 bg-lGray900': !active && !dragging && !ghost && !preview,
    'border-lGray600 bg-lGray850 shadow-soft-black': active || ghost || preview,
    'cursor-pointer': clickable && !ghost
  }"
  (click)="onCardClick()"
>
  @if (showDragHandle) {
    @if (ghost) {
      <span
        class="flex shrink-0 items-center justify-center text-lGray600 opacity-0"
        aria-hidden="true"
      >
        <l-icon class="text-2xl">menu</l-icon>
      </span>
    } @else {
      <button
        type="button"
        cdkDragHandle
        class="flex shrink-0 cursor-grab touch-none items-center justify-center text-lGray600 transition-colors active:cursor-grabbing"
        [attr.aria-label]="dragHandleAriaLabel"
        (click)="$event.stopPropagation()"
      >
        <l-icon class="text-2xl">menu</l-icon>
      </button>
    }
  }

  <div class="flex min-h-12 min-w-0 flex-1 items-center gap-3">
    <ng-content />
  </div>

  <ng-content select="[sortableCardActions]" />
</article>
